module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-24-1dc979deafc8899bbb77999e17471ef8.svg";